export default {
  componentName: 'at-the-tanks',
  exampleImgUrl:
    'https://drive.google.com/open?id=1kZsDutLdWhHBSEM32_2Y9SILOjYdhFYT',
  nickname: 'At The Tanks',
  pageList: [
    'https://www.bassmaster.com/leaderboard/tournaments/2018-bassmaster-team-championship',
  ],
  renderId: 'react-app--at-the-tanks',
};
